import { Store } from "pullstate";
import { UserClaim } from "types/claimTypes";

export type AuthStore = {
  id: string | null;
  email?: string | null;
  isLoggedIn?: boolean;
  firstName?: string | null;
  lastName?: string | null;
  impersonatedUserEmail?: string | null;
  claims: (UserClaim | undefined)[];
};

const authStore = new Store<AuthStore>({
  id: null,
  isLoggedIn: false,
  claims: [],
});

export default authStore;
